import React, { forwardRef } from 'react';
import InputTemplate from '../TemplateNumberFormatInput';

const PorcentagemInput = forwardRef(({ escala = 3, ...props }, ref) => (
  <InputTemplate {...props} escala={escala} sufixo="%" ref={ref} />
));

export default PorcentagemInput;
